export default {
  topDialogState: state => state.dialogStack.length > 0 ? state.dialogStack[state.dialogStack.length - 1] : undefined,
  topDialogId: state => state.dialogStack.length > 0 ? state.dialogStack[state.dialogStack.length - 1].id : '',
  dialogCount: state => state.dialogStack.length,
  hasOpenDialog: state => state.dialogStack.length > 0,
  hasOpenDialogById: state => id => state.dialogStack.findIndex(dialogState => dialogState.id === id) !== -1,
  dialogStateById: state => id => state.dialogStack.find(dialogState => dialogState.id === id),
  isTopDialogById: state => id => state.dialogStack.length > 0 && state.dialogStack[state.dialogStack.length - 1].id === id,
  allowEscapeToClose: state => state.allowEscapeToClose,
  hasConfirmCloseDialogAbove: state => id => {
    const index = state.dialogStack.findIndex(ds => ds.id === id)
    if (index === -1) return false
    return state.dialogStack.slice(index + 1).some(ds => ds.requiresConfirmClose)
  }
}
